import styled from 'styled-components';

export const TableCellWrapperStyled = styled.div`
  margin-left: 8px;
  display: flex;
  align-items: center;
`;

export const StaticCellPaddingStyled = styled.div`
  margin: 12px 0px;
  min-width: 125px;
`;

export const SelectCellPaddingStyled = styled.div`
  margin: 4px 0px;
`;

export const LozengeCellPaddingStyled = styled.div`
  margin-top: 16px;
  min-width: 125px;
`;

export const ButtonCellPaddingStyled = styled.div`
  margin-left: -12px;
  margin-top: 8px;
`;

export const DeleteButtonContainerStyled = styled.div`
  margin-top: 8px;
`;
